module.exports = __webpack_public_path__ + "img/07-md.1da9f27.webp";